import React from 'react';

type IconButtonProps = {
  title?: string;
  ariaLabel?: string;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
  testId?: string;
  children?: React.ReactNode;
};

export default function IconButton({ title, ariaLabel, onClick, disabled = false, testId, children }: IconButtonProps) {
  return (
    <button
      className="subtle-btn icon"
      title={title}
      aria-label={ariaLabel}
      onClick={onClick}
      disabled={disabled}
      data-testid={testId}
    >
      {children}
    </button>
  );
}
